module.exports = __webpack_public_path__ + "static/media/kd.4800caeb.svg";